import { render } from "./UsuariosPage.vue?vue&type=template&id=04d3e487"
import script from "./UsuariosPage.vue?vue&type=script&lang=js"
export * from "./UsuariosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__